<template>
  
  <span>

    <b-container fluid>

      <b-alert 
        variant="warning" 
        :show="displayCookieWarning" 
        @dismissed="setCookie"
        dismissible 
        class="mt-1 alert-modern">
        
        This site uses cookies to provide you with a great user experience.  
        By using Principal Task, you accept our use of cookies as stated
        in the <b-link to="/privacy-policy">Privacy Policy</b-link>.
      
      </b-alert>
    
      <router-view />

    </b-container>



      <b-container fluid id="sticky-footer" class="mt-5 mb-0 py-5 footer-modern" style="position: relative; bottom: 0; width:100%">

        <b-row cols="1" cols-md="4">

          <b-col style="text-align:center; vertical-align:middle">

            <p class="lead">
              Social
            </p>
            
            <b-link
              class="mx-2"
              target="_pt-social"
              href="https://www.facebook.com/principaltask">
              
              <b-img 
                :src="require('./assets/facebook.png')" 
                alt="Facebook"
                height="24" 
                width="24"/>
            
            </b-link>

            <b-link
              class="mx-2"
              target="_pt-social"
              href="https://indieapps.space/@principaltask"
              rel="me">
              
              <b-img 
                :src="require('./assets/mastodon.svg')" 
                alt="Mastodon"
                height="24" 
                width="24"/>
            
            </b-link>

            <b-link
              target="_pt-social"
              href="https://reddit.com/u/principaltask">
              
              <b-img 
                :src="require('./assets/reddit.svg')" 
                alt="Reddit"
                height="24" 
                width="24"
                class="mx-2"/>
            
            </b-link>
            
            <b-link
              target="_pt-social"
              href="https://twitter.com/PrincipalTask">
              
              <b-img 
                :src="require('./assets/x.png')" 
                alt="X (formerly Twitter)"
                height="24" 
                width="24"
                class="mx-2"/>
            
            </b-link>

            

          </b-col>
          <b-col style="text-align:center; vertical-align:middle">
            <p class="lead">
              Site
            </p>
                       
            <small>
            <ul class="list-unstyled">
              <li>
                <b-link href="https://www.principaltask.com/features.html" target="_blank">Features</b-link><br/>
                <b-link :to="{name:'gallery-public'}">Gallery</b-link><br/>
                <b-link href="https://www.principaltask.com/pricing.html" target="_blank">Pricing</b-link><br/>               
                
              </li>
              
            </ul>
            </small>

          </b-col>

          <b-col style="text-align:center; vertical-align:middle">

            <p class="lead">
              Tasks
            </p>

            <small>
            <ul v-if="!$auth.loading && $auth.isAuthenticated" class="list-unstyled" >
              <li><b-link to="/dashboard">Dashboard</b-link></li>
              <li><b-link href="/tasks/get-organized">Get Organized</b-link></li>
              <li><b-link href="/tasks/overdue">Overdue</b-link></li>
              <li><b-link href="/tasks/this-week">This Week</b-link></li>
              <li><b-link href="/tasks/todays-focus">Today's Focus</b-link></li>
              <li><b-link href="/tasks/custom">Custom</b-link></li>
            </ul>

            <ul v-else class="list-unstyled" >
              <li><b-link :to="{name: 'dashboard'}">Sign In</b-link></li>
            </ul>

            </small>

          </b-col>

          <b-col style="text-align:center; vertical-align:middle">
            
            <p class="lead">
              Legal
            </p>
                       
            <small>
            <ul class="list-unstyled">
              <li><b-link href="https://www.principaltask.com/privacy.html" target="_blank">Privacy Policy</b-link></li>
              <li><b-link href="https://www.principaltask.com/agreement.html" target="_blank">User Agreement</b-link></li>
            </ul>
            </small>

            <p class="lead">
              Support
            </p>
                       
            <small>
            <ul class="list-unstyled">
              <!-- <li>
                <a href="#" class="changelogfy-icon">
                  Change Log
                  <Changelogfy
                    app-id="ab61c98c-c61b-474c-ba7c-ded70f83abcd"
                    selector=".changelogfy-icon"
                    :init-badge="false"
                  />
                </a>
              </li>               -->
              <li>
                <b-link href="mailto:support@principaltask.com">support@principaltask.com</b-link>
              </li>
              
            </ul>
            </small>
            
          </b-col>

        </b-row>
        
        
        <b-row>

          <b-col style="text-align:center; vertical-align:middle">

            

            <small>
              <b-link href="https://www.schwenktechnologygroup.com" target="_blank" class="text-white-50">Schwenk Technology Group</b-link>
              &copy; 2019-{{ new Date().getFullYear() }}
            </small>
            
            

          </b-col>
      </b-row>
        

      </b-container>


  </span>

</template>

<script>

	
  import Changelogfy from 'changelogfy-vuejs';
	import taskOps from './mixins/taskOps'
  import genericOps from './mixins/genericOps'

	export default {
		name: 'App',
		components: {
      Changelogfy
		},
		mixins: [taskOps, genericOps],
        data() {
          return {
            task: {},
			}
        },
		computed: {
      

    },
    watch: {
      '$route' (to, from) {
        document.title = to.meta.title || 'Principal Task'
      }
    },
		mounted() {
      // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed debug console.log statements
		},
		methods: {
      login(goTo) {
        // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed debug console.log statements
        
        let uri = ''

        if(goTo) {

          uri = window.location.origin + goTo

        } else {
          uri = window.location.origin
        }

        ////console.log("URI = " + uri)
        
        this.$auth.loginWithRedirect({
          redirect_uri: uri
        });
			},
			logout() {
				this.$auth.logout({
					returnTo: process.env.VUE_APP_ENV_LOGOUT_URL || 'https://www.principaltask.com'
				});
			}
		}
	}
</script>

<style>
html,
body {
  height: 100%;
}

#page-content {
  flex: 1 0 auto;
}


</style>